const FORM_MATRIX_SWITCH_ITEMS = [
  { id: "icd", label: "Icd" },
  { id: "dosage", label: "Dosage" },
  { id: "dosageInstr", label: "Dosage Instr." },
  { id: "ev", label: "EV" },
  { id: "daw", label: "DAW" },
  { id: "reviewNeeded", label: "Review Needed" },
] as const;

export default FORM_MATRIX_SWITCH_ITEMS;
